import Cell from "./Cell";
import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class Reel {
    constructor(x, y, index, cellCreation, expanding) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 50;
        this.suspenseDuration = 3000;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        this.index = index;
        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = this.numOfCellsPerReel + this.numOfExtraCellsPerReel - 1;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        this.container = layoutBuilder.findByPath(`Basegame/grid/reels/reel_${index}`);
        this.cells = cellCreation.cells;
        this.cellPosition = cellCreation.cellPositions;
        this.soundScatterInReel = ResourcesDispatcher.SOUNDS.SCATTER_IN_REEL;
        this.soundReelSuspence = ResourcesDispatcher.SOUNDS.RULLO_SUSPENSE;
        if (expanding) {
            this.expandingWild = expanding;
            this.container.add(this.expandingWild.getContainer());
        }
    }
    setIndex(index) {
        this.index = index;
    }
    /** PUBLIC GETTERS **/
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    getCell(index) {
        return this.cells[index];
    }
    getCells() {
        return this.cells;
    }
    /*******************/
    enableSuspense() {
        this.suspense = true;
    }
    setReelBackgroundSuspense() {
        scene.gameArea.turnoOnSuspense(this.index);
    }
    resetReelBackground() {
        scene.gameArea.turnoOffSuspense();
    }
    resetFlagsAndCounters() {
        this.resetReelBackground();
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, scene.gameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.suspense = false;
        this.canStop = false;
        this.mustStop = false;
        this.suspenseStarted = false;
        this.mustEnableSuspense = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    turnOn() {
        this.getCells().forEach(c => c.turnOn());
    }
    turnOff() {
        this.getCells().forEach(c => c.turnOff());
    }
    resetCellsPositions() {
        return;
        this.getCells().forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }
    reIndexCells() {
        let resetCells = [];
        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {
            resetCells[i - 1] = this.getCell(i);
            this.getCell(i).setIndex(i - 1);
        }
        this.getCell(0).setIndex(this.lastCellIndex);
        resetCells[this.lastCellIndex] = this.getCell(0);
        this.cells = resetCells;
    }
    configureSpinTween() { }
    spin() {
        this.spinProgress.play();
    }
    //TODO Refattorizzare l'animazione del bounce della singola cella
    playAnimationBounceSingleCell(cell, memoIndex) {
        const anims = cell.getSymbolSpineRaw(memoIndex).animations;
        if (anims && anims.length > 1) {
            const spine = cell.getSpine(memoIndex);
            const track = spine.animationState.addAnimation(Cell.WinAnimationTrack, anims[1], false); // <-- animations[1]
            track.alpha = Cell.WinAnimationAlpha;
            spine.setVisible(true);
            cell.getImage().setVisible(false);
            track.listener = {
                complete: () => {
                    // ripristino come fa playAnimation()
                    spine.setVisible(false);
                    spine.skeleton.setToSetupPose();
                    cell.getImage().setVisible(true);
                }
            };
        }
    }
    ;
    bounce() { }
    manageSuspense() {
        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }
        if (this.mustEnableSuspense && !this.forced) {
            scene.gameArea.reels[this.index + 1].startSuspense();
            this.stopEvent = scene.time.addEvent({
                delay: this.suspenseDuration,
                callbackScope: this,
                callback: () => {
                    scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        }
        else if (this.mustEnableStop && !this.forced) {
            this.stopEvent = scene.time.addEvent({
                delay: this.spinAnimationDuration * (this.lastCellIndex),
                callbackScope: this,
                callback: () => {
                    scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        }
        // if (this.index === this.numOfReels - 1 || this.index === scene.gameArea.lastReelWithSuspense) {
        //     // stop scatter that are currently animating, if any
        //     scene.gameArea.reels.forEach((reel:any) => {
        //         reel.cells.forEach((_cell:any) => {
        //         });
        //     });
        // }
    }
    startSuspense() {
        this.setReelBackgroundSuspense();
        this.turnOff();
        this.suspenseStarted = true;
        soundManager.play(this.soundReelSuspence);
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    stopReelSuspenseAnimation() {
        if (this.suspense && this.suspenseStarted) {
            this.suspense = false;
            this.suspenseStarted = false;
            this.resetReelBackground();
            this.turnOn();
        }
    }
    forceStop() {
        this.canStop = true;
        this.mustStop = true;
        this.forced = true;
        this.getCells().forEach(cell => cell.stopAnimation());
        this.removeStopEvent();
        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }
        soundManager.stop(this.soundReelSuspence);
    }
    refreshCellPositions() {
        const numOfCells = this.numOfCellsPerReel + this.numOfExtraCellsPerReel;
        for (let i = 0; i < numOfCells; i++) {
            const node = layoutBuilder.getNodeByPath(`Basegame/grid/reels/reel_${this.index}/cell_${i}`);
            if (node) {
                this.cellPosition[i] = {
                    x: node.coordinates.relative_top_left_to_parent?.x || 0,
                    y: node.coordinates.relative_top_left_to_parent?.y || 0
                };
            }
        }
        this.getCells().forEach(cell => {
            const pos = this.cellPosition[cell.getIndex()];
            if (pos) {
                cell.getContainer().setPosition(pos.x, pos.y);
                cell.refreshInternalPositions();
            }
        });
    }
}
